export const AppsNotAuthSupported: string[] = ['System Status'];
